<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
        Uprawnienia
        <div class="mb-6 flex justify-between items-center">
          <inertia-link class="btn-shtax ml-auto absolute right-0 top-0 disabled:opacity-50" :href="route('permissions.create')">
            <span>Nowe</span>
            <span class="hidden md:inline">uprawnienie</span>
          </inertia-link>
        </div>
    </h1>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nazwa</th>
          <th class="px-6 pt-6 pb-4">Przestrzeń</th>
        </tr>
        <tr v-for="permission in permissions" :key="permission.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('permissions.edit', permission.id)">
              {{ permission.name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('permissions.edit', permission.id)" tabindex="-1">
              {{ permission.guard_name }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('permissions.edit', permission.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="permissions.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Brak określonych uprawnień.</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Uprawnienia użytkowników' },
  components: {
    Icon
  },
  layout: Layout,
  props: {
    permissions: Array
  },
  data() {
    return {
    }
  }
}
</script>
